import React from 'react';
import { useTranslation } from 'react-i18next'
import { Add, Copy, Down, Edit, Remove, Up, View } from '../../../components/Icons/Icons';

const DeleteAllUsers = ({ deleteAllPractitioners }) => {
    const { t } = useTranslation();

    return (
        <div className="col-md-3">
            <button type="button" className="btn btn-danger" onClick={deleteAllPractitioners}><Remove />{t('protocols.groups.deleteAll')}</button >
        </div>
    );
};

export default DeleteAllUsers;